import React, { useEffect, useState } from 'react'
import BossDialog from '../../../components/BossDialog'
import { useTranslation } from '../../../locale/useTranslation'
import { EditPageHeader } from '../../../components/EditPageHeader';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import moment from 'moment';
import { utility } from '../../../framework/utility/utilityProvider';
import { ENTITYNAME, FILEURL, LOCALSTORAGE_KEY, TOAST_TYPES } from '../../../framework/constant/constant';
import * as API from '../../../framework/API/api';
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import ActionButton from '../../../framework/forms/helpercomponents/buttons/ActionButton';
import { DateTimeCell } from '../../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import RoundButton from '../../../framework/forms/helpercomponents/buttons/RoundButton';
import ToastNotification from '../../../components/ToastNotification';

const MissingSegmentMamReport = ({ item = {}, onClose }) => {

    const lang = useTranslation();
    const weekStartDay = utility.getValue(LOCALSTORAGE_KEY.planningpreference)?.data[0]?.value?.weekStartDay ?? { _id: 0, Description: "Sunday", bgColor: "#f76969" };
    const getStartOfWeek = (date, weekStartId) => {
        const day = date.day();
        const diff = (day - weekStartId + 7) % 7;
        return date.clone().subtract(diff, 'days').startOf('day');
    };

    const getEndOfWeek = (startDate) => {
        return startDate.clone().add(6, 'days').endOf('day');
    };

    const planningDate = moment(item?.planningdate).utc();
    const startOfWeek = getStartOfWeek(planningDate, weekStartDay?._id);
    const endOfWeek = getEndOfWeek(startOfWeek);

    const blankDataItem = {
        FromDate: startOfWeek.format('YYYY-MM-DD'),
        ToDate: endOfWeek.format('YYYY-MM-DD'),
        Channel: item?.channels?.length > 0 ? item.channels[0] : {}
    }
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [channels, setChannels] = useState([]);
    const [gridData, setGridData] = useState([]);

    useEffect(() => {
        loadCombo();
        loadData();
    }, []);

    const loadCombo = async () => {
        let channelRes = await API.getValidChannels(ENTITYNAME.Channel);
        setChannels(channelRes.data);
    }

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

    const isValid = () => {
        if (!dataItem.Channel || Object.keys(dataItem.Channel).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false;
        }
        if (!dataItem.FromDate || dataItem.FromDate == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_from_date_error_message });
            return false;
        }
        if (!dataItem.ToDate || dataItem.ToDate == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_error_message });
            return false;
        }
        return true;
    }

    const loadData = async () => {
        if (!isValid()) return;
        let payload = {
            ChannelSID: dataItem?.Channel?.SID,
            FromDate: utility.convertStringDatetoMilliseconds(dataItem.FromDate),
            ToDate: utility.convertStringDatetoMilliseconds(dataItem.ToDate),
            IsExport: false
        }
        console.log(payload);
        let res = await API.exportMissingSegmentMamReport(payload);
        console.log(res);

        if (res.success) {
            setGridData(res.data);
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const handleExport = async () => {
        if (!isValid()) return;
        let payload = {
            ChannelSID: dataItem?.Channel?.SID,
            FromDate: utility.convertStringDatetoMilliseconds(dataItem.FromDate),
            ToDate: utility.convertStringDatetoMilliseconds(dataItem.ToDate),
            IsExport: true
        }
        console.log(payload);
        let res = await API.exportMissingSegmentMamReport(payload);
        console.log(res);

        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.fileName);
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Successfully Exported!" });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    return (
        <BossDialog title={lang.missing_segment_planning_report_dialog_header} width={"850px"} onClose={onClose}>
            <div className="row mt-2">
                <div className="col-4">
                    <label htmlFor="">{lang.channel_label}</label>
                    <DropDownList
                        data={channels}
                        textField="FullChannelName"
                        dataItemKey="SID"
                        name='Channel'
                        value={dataItem.Channel}
                        onChange={onChange}
                    />
                </div>
                <div className="col-3">
                    <label htmlFor="">{lang.from_label}</label>
                    <input className="form-control form-control-sm" type='date' name="FromDate" value={dataItem.FromDate} label={lang.from_date_label} onChange={onChange} />
                </div>
                <div className="col">
                    <label htmlFor="">{lang.to_label}</label>
                    <div className='d-flex'>
                        <input className="form-control form-control-sm" type='date' name="ToDate" value={dataItem.ToDate} label={lang.to_date_label} onChange={onChange} />
                        <ActionButton name={lang.show_button_text} style={{ marginTop: "-5px" }} onClick={loadData} />
                    </div>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col-12 mt-2">
                    <div className='d-flex'>
                        <div className='mr-auto font-weight-bold'>{lang.segment_and_mam_label}</div>
                        <RoundButton icon={'download'} title={lang.export_button_tooltip} onClick={handleExport} />
                    </div>
                    <Grid data={gridData} style={{ height: "400px" }}>
                        <GridColumn field="mediaEpisode.AssetId" title={lang.assetId_column} />
                        <GridColumn field="SlotDateTime" title={lang.planned_slot_time_label} cell={DateTimeCell} width={180} />
                        <GridColumn field="mediaEpisode.Title" title={lang.title_column} />
                        <GridColumn field="mediaEpisode.ReferenceCode" title={lang.reference_code_column} />
                        <GridColumn field="MamID" title={lang.mam_id_column} />
                    </Grid>
                </div>
            </div>
        </BossDialog>
    )
}

export default MissingSegmentMamReport;